import React from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import framePng from './assets/frame.png';
import { MobilePreviewProps } from './types';
import * as styles from './MobilePreview.css';

export const MobilePreview = ({
  primaryColor = '#000000',
  bannerImage,
  children,
}: MobilePreviewProps) => {
  const bannerUrl = bannerImage ? `url("${bannerImage}")` : undefined;

  return (
    <div
      id="mobile-preview"
      className={styles.previewWrapper}
      style={assignInlineVars({
        [styles.colorVar]: primaryColor,
      })}
    >
      <div className={styles.phoneContainer}>
        <img src={framePng} className={styles.frameImage} />
        <div className={styles.phoneContent}>
          <div
            className={styles.banner}
            style={assignInlineVars({
              [styles.backgroundImageVar]: bannerUrl || 'none',
              [styles.colorVar]: primaryColor,
            })}
          />
          <div className={styles.contentContainer}>{children}</div>
        </div>
      </div>
    </div>
  );
};
